
<app-user-header></app-user-header>

<div class="container-fluid container-m-t">
    <div class="row">
        <div class="col-sm-3 left-panel-mobile-view">
                <div class="row h-105">
                        <!-- left sidebar -->
                        <div class="col-md-10 fixed pl-0 py-2 left left-sidebar">
                            <ul class="nav flex-md-column flex-nowrap justify-content-center screen-1280-styles m-l-ipad">
                                <li class="img-circle-styles" style="text-align: center; margin-top: 34px;"><img style="    border: 1px solid #FFF;border-radius: 49%;width: 40%;height: 40%;"
                                        src="assets/images/user-image.png" class="img-circle" alt="Cinque Terre">
                                    <h5 class="center user-text" style="text-align:  center;">
                                        {{ramki.firstName + "  "+ ramki.lastName}}</h5>
                                </li>
                
                                <!-- <li>
                                    <a class="nav-link">
                                        <form [formGroup]="form" class="form-styles">
                                            <div class="form-group">
                                                <label for="year">Tax Year</label>
                                                <select  class="form-control">
                                                    <option disabled>Select Year</option>
                                                    <option disabled>Choose Year</option>
                                                    <option >{{yr}}</option>
                                                </select>
                                                <div *ngIf="f.year.touched && f.year.invalid" class="alert alert-danger">
                                                    <div *ngIf="f.year.errors.required">Please Select Tax Year</div>
                                                </div>
                                            </div>
                                        </form>
                                    </a>
                                </li> -->
                
                                          
                                <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Dashboard">
                                    <a class="nav-link font-size-ipad" routerLink="/dashboard">
                                        <img src="assets/images/dashboard.svg" style="width: auto; height: auto;">&nbsp;
                                        <span class="nav-link-text sidebar-text">Dashboard</span>
                                    </a>
                                </li><br>
                
                                <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Basic Information">
                                    <a class="nav-link font-size-ipad" routerLink="/basic">
                                        <img src="assets/images/information.svg" style="width: auto; height: auto;">&nbsp;
                                        <span class="nav-link-text sidebar-text">Basic Information</span>
                                    </a>
                                </li><br>
                                <li class="nav-item" data-toggle="tooltip" data-placement="right" title="My Documents" style="background: black;">
                                    <a class="nav-link font-size-ipad" routerLink="/documents">
                                        <img src="assets/images/doc.svg" style="width: auto; height: auto;">&nbsp;
                                        <span class="nav-link-text sidebar-text" style="color: white;">My Documents</span>
                                    </a>
                                </li><br>
                                <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Download Tax Return">
                                    <a class="nav-link font-size-ipad"  routerLink="/download">
                                        <img src="assets/images/tax.svg" style="width: auto; height: auto;">&nbsp;
                                        <span class="nav-link-text sidebar-text">Download Tax Return</span>
                                    </a>
                                </li><br>
                                <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Make A Payment">
                                    <a class="nav-link font-size-ipad" routerLink="/payment">
                                        <img src="assets/images/payment.svg" style="width: auto; height: auto;">&nbsp;
                                        <span class="nav-link-text sidebar-text">Make A Payment</span>
                                    </a>
                                </li><br>
                                <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Consent Of Disclosure">
                                    <a class="nav-link font-size-ipad" routerLink="/disclosure">
                                        <img src="assets/images/disclosure.svg" style="width: auto; height: auto;">&nbsp;
                                        <span class="nav-link-text sidebar-text">Consent Of Disclosure</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                
                </div>
        </div>
        <!-- <div class="col-sm-1"></div> -->
        <div class="col-sm-9 col-m-t">
            <div class="dash-row">Upload Documents</div>
            <br>
 
            <div class="container">                    
                <form [formGroup]="form" (ngSubmit)="submit()" class="form-styles">
                        
                    <div class="form-group">
                        <label for="website">File Type</label>
                        <select #mySelected formControlName="website" class="form-control" >
                            <!-- <option disabled>Choose File</option> -->
                            <!-- <option>Choose Type</option> -->
                            <option value="" disabled selected>-----------------Choose Type ------------------</option>
                            <option  placeholder="Please" [value]="file.category+ '||'  +file.id" *ngFor="let file of sri" >{{file.category}}</option>
                        </select>
                        <div *ngIf="f.website.touched && f.website.invalid" class="alert alert-danger">
                            <div *ngIf="f.website.errors.required">Please Select File Type</div>
                        </div>
                    </div> 
                    <br>
                    <div class="form-group" style="padding: 10px;border: 1px solid #ced4da;">
                        <label for="file">Choose File</label> &nbsp;
                        <input type="file" (change)="fileProgress($event)" 
                        class="form-control" formControlName="chooseFile">
                    </div>
                   <div>
                    <button class="btn btn-styles" type="submit" [disabled]="!form.valid">Upload</button>
                   </div>
                </form>
            </div>

                <div class="footer" style="text-align: center;background-color: #e9ecef;
                line-height: 55px; color: black;">
                        Copyright ©2020 Evolvtax Services Pvt Ltd. All rights reserved
                </div>
        </div>
    </div>

    <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">  
        <p style="color: white">Loading </p>  
        </ngx-spinner>
</div>
